export const iconFontAwesomeHumanitarianTowerCell = (
	<i className="fa-solid fa-tower-cell"></i>
);
